export const headersByFieldNames = {
    number: 'PAYOUT_NUMBER',
    shipmentId: 'SHIPMENT_ID',
    item: 'ITEM',
    date_created: 'DATE_CREATED',
    due_date: 'DUE_DATE',
    total: 'TOTAL',
    status: 'STATUS',
    actions: 'ACTIONS',
};
